// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"Sidebar_Sidebar__33SN-","SidebarIcon":"Sidebar_SidebarIcon__352m_"};